import styled from 'styled-components';

const FilterPostsStyle = styled.div`
	--distanceButtonGap: var(--sp2x);
	--distanceTOP: var(--sp7x);
	--distanceBottom: var(--sp9x);

	display: flex;
	flex-wrap: wrap;
	gap: var(--distanceButtonGap);
	margin-top: var(--distanceTOP);
	margin-bottom: var(--distanceBottom);

	.category {
		a,
		button {
			text-transform: capitalize;
		}

		&.active {
			pointer-events: none;
			cursor: default;
			a,
			button {
				color: var(--backgroundColor);
				background-color: var(--mainColor);
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceButtonGap: var(--sp2x);
		--distanceTOP: var(--sp5x);
		--distanceBottom: var(--sp7x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTOP: var(--sp4x);
		--distanceBottom: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceButtonGap: var(--sp1-5x);
		--distanceTOP: var(--sp3x);
		--distanceBottom: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceButtonGap: var(--sp1x);
	}
`;
export default FilterPostsStyle;
